import { useLocation } from 'react-router-dom';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { usePageHistory } from '@/utils/hooks/usePageHistory';

import Navbar from '@/components/layouts/navbar';
import DashboardSidebar from '@/components/layouts/dashboard-sidebar';

interface ClientLayoutProps {
  children?: React.ReactNode;
}

export default function ClientLayout({ children }: ClientLayoutProps) {
  const { pathname } = useLocation();

  const isAuthPage =
    pathname === '/login' ||
    pathname === '/register' ||
    pathname === '/forgot-password';

  if (isAuthPage) {
    return <div className="bg-background min-h-screen w-full">{children}</div>;
  }

  usePageHistory();

  return (
    <SidebarProvider>
      <div className="relative flex min-h-screen w-full">
        <DashboardSidebar />
        <SidebarInset className="z-0 flex w-full flex-col overflow-hidden">
          <Navbar />
          <div className="flex-1 overflow-x-hidden overflow-y-auto p-4">
            {children}
          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
}
